import { Action, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { Streets } from './streets.model';
import * as StreetsActions from './streets.actions';

export const streetsesFeatureKey = 'streetses';

export interface State extends EntityState<Streets> {
  // additional entities state properties
}

export const adapter: EntityAdapter<Streets> = createEntityAdapter<Streets>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(StreetsActions.addStreets,
    (state, action) => adapter.addOne(action.streets, state)
  ),
  on(StreetsActions.upsertStreets,
    (state, action) => adapter.upsertOne(action.streets, state)
  ),
  on(StreetsActions.addStreetss,
    (state, action) => adapter.addMany(action.streetss, state)
  ),
  on(StreetsActions.upsertStreetss,
    (state, action) => adapter.upsertMany(action.streetss, state)
  ),
  on(StreetsActions.updateStreets,
    (state, action) => adapter.updateOne(action.streets, state)
  ),
  on(StreetsActions.updateStreetss,
    (state, action) => adapter.updateMany(action.streetss, state)
  ),
  on(StreetsActions.deleteStreets,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(StreetsActions.deleteStreetss,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(StreetsActions.loadStreetss,
    (state, action) => adapter.setAll(action.streetss, state)
  ),
  on(StreetsActions.clearStreetss,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
